export const SET_APP_LOADING = 'SET_APP_LOADING';
export const SET_APP_ERROR = 'SET_APP_ERROR';
export const SET_USER_DATA = 'SET_USER_DATA';

export const SET_CHAIN_DATA = 'SET_CHAIN_DATA';
